import axios from 'axios';

const mentoriaFinancieraURL = process.env.REACT_APP_MENTORIA_FINANCIERA_TRANSVERSAL || '';
const mentoriaFinancieraApiKey = process.env.REACT_APP_MENTORIA_FINANCIERA_API_KEY || '';

export const obtenerParametros = async () => {
	const response = await axios.get(
		`${mentoriaFinancieraURL}financial/get-params`,{
			headers: {
				ApiKey: mentoriaFinancieraApiKey,
				'Content-Type': 'application/json',
			},
		});
	return response.data;
};
